import { render, staticRenderFns } from "./stats_relances.vue?vue&type=template&id=bf0691c8&scoped=true&"
import script from "./stats_relances.vue?vue&type=script&lang=js&"
export * from "./stats_relances.vue?vue&type=script&lang=js&"
import style0 from "./stats_relances.vue?vue&type=style&index=0&id=bf0691c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0691c8",
  null
  
)

export default component.exports